module.exports = __webpack_public_path__ + "static/media/cash-minsk.cec92794.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cash-minsk.png
// module id = 503
// module chunks = 0